import React from 'react';

import "./Navbar.css";

import Links from "../Links";

export default function Navbar(props) {
  return <div className="portfolio-header mdl-layout__header mdl-layout__header--waterfall mdl-shadow--4dp">
    <div className="mdl-layout__header-row">
      <span className="portfolio-title mdl-layout-title">
        <img alt="logo" className="portfolio-logo-image" src="images/alm-logo.png" />
      </span>
      <div className="mdl-layout-spacer"></div>
      <div className="portfolio-navigation-container">
        <Links upper={true} />
      </div>
      <span className="portfolio-mobile-title mdl-layout-title">
        <img alt="logo" className="portfolio-logo-image" src="images/alm-logo.png" />
      </span>
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/Navbar/Navbar.js